import React, {useEffect, useState} from "react";
import {useHistory, useParams, withRouter} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";
import {getLeagueDivisions} from "../../../services/leagues";
import {useTranslation} from "react-i18next";

// React Components
import Header from "../../../components/Header";
import Card from "../../../components/Card/Card";
import ScaleLoader from "react-spinners/ScaleLoader";

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
    `;

const LeagueDivisionSelection = (props) => {
   const [leagueDivisions, setLeagueDivisions] = useState(null);
   const [loading, setLoading] = useState(true);
   const history = useHistory();
   const {t} = useTranslation();
   let {leagueId, leagueEditionId} = useParams();

   useEffect(() => {
      (async () => {
         let leagueDivisions = await getLeagueDivisions(leagueId);

         setLeagueDivisions(leagueDivisions);
         setLoading(false);
      })()
   }, []);

   return <div className={"LeagueDivisionSelection"}>
      <Header headerBarTitle={t("other_leagues_page.header")} showBackButton/>

      <Container className={"desktop"}>
         <Row>
            <Col className={"pb-3"} xs={12} sm={12}>
               <p>{t("other_leagues_page.select_division")}</p>
            </Col>
         </Row>

         <ScaleLoader
            css={override}
            sizeUnit={"px"}
            size={30}
            color={'#AFFF55'}
            loading={loading}
         />

         <Row>
            {!loading && leagueDivisions.map(leagueDivision => {
               return <Card
                  key={leagueDivision.id}
                  text={leagueDivision.name}
                  onClick={() => history.push(`/other-leagues/${leagueEditionId}/leagues/${leagueId}/league-divisions/${leagueDivision.id}/details`,
                     {leagueCategoryId: leagueDivision.league_category_id})
                  }
               />
            })}
         </Row>
      </Container>
   </div>
}

export default withRouter(LeagueDivisionSelection);
